import { useParams } from "react-router-dom";
import ProductDescription from "./components/ProductDescription";
import ProductImages from "./components/ProductImages";
import ProductSelection from "./components/ProductSelection";
import { Box, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getProductDetails } from "../../helpers/httpRequests/products";
import CustomContainer from "../../components/CustomContainer";
import LoadingComponent from "../../components/LoadingComponent";
import PageHeader from "../../components/PageHeader";

const styles = {
    wrapper: {
        bgcolor: 'transparent',
        minHeight: '70vh',
        py: { xs: '2rem', md: '3rem' },
    },
};

export default function ProductDetails() {

    const { id } = useParams();

    const { data, isFetching } = useQuery({ queryKey: ['getProductDetails', id], queryFn: () => getProductDetails(id), staleTime: 1000 * 50 });

    const productData = data?.data?.data;

    if (isFetching) {
        return <LoadingComponent />
    };

    return (
        <CustomContainer>
            <Box sx={styles.wrapper}>
                <PageHeader
                    crumbs={[{ label: 'Produtos', to: '/produtos' }, productData?.name || 'Detalhes']}
                />

                <Grid container spacing={6}>

                    <ProductImages {...productData} />

                    <ProductSelection {...productData} />

                    <ProductDescription {...productData} />

                </Grid>
            </Box>
        </CustomContainer>
    );
};
